export default __webpack_public_path__ + "static/media/vpay-logo.0ce6830d.svg";